import { render, staticRenderFns } from "./gopage.vue?vue&type=template&id=4ee2e4b0&scoped=true&"
import script from "./gopage.vue?vue&type=script&lang=js&"
export * from "./gopage.vue?vue&type=script&lang=js&"
import style0 from "./gopage.vue?vue&type=style&index=0&id=4ee2e4b0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2e4b0",
  null
  
)

export default component.exports